import PaymentRequestsTableColumnCost from './index.vue'
export default PaymentRequestsTableColumnCost